import _find from "lodash/find";
import { batch } from "react-redux";
import { RecievedTokenPayload } from "@/redux/slice/auth/types/RecievedTokenPayload";
import { FetchPatientPayload } from "@/redux/slice/auth/types/FetchPatientPayload";
import fetchPatientApi from "@/redux/slice/auth/apis/fetchPatientByMobileNumber";
import { GetPatientsPayload } from "@/redux/slice/auth/types/GetPatientsPayload";
import getCurrentPatientsApi from "@/redux/slice/auth/apis/getCurrentPatients";
import {
  updateCurrentPatientId,
  updatePatientList,
  updateSignedInState,
  updateSignInError,
} from "@/redux/slice/auth/slice";
import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import { setCookie } from "@/helpers/cookies";
import { LOGIN_COOKIE_NAME } from "@/libs/constants/auth";
import performSignOutUpdates from "@/redux/slice/auth/actions/performSignOutUpdates";
import primaryProfileId from "@/redux/slice/auth/utils/primaryProfileId";
import { Patient } from "@/redux/slice/auth/types/Patient";
import { clevertapUserLoginTracking } from "@/libs/clevertapTracking";

export default async function recievedTokenFetchPatients(
  payload: RecievedTokenPayload & {
    dispatch: any;
  }
) {
  const { apolloClient, store, dispatch, mobileNumber } = payload;

  try {
    const fetchPatientPayload: FetchPatientPayload = {
      apolloClient,
      mobileNumber,
    };
    const fetchPatientsResponse = await fetchPatientApi(fetchPatientPayload);

    if (!fetchPatientsResponse?.errors?.length) {
      const patientList = fetchPatientsResponse?.data?.getPatientByMobileNumber?.patients;

      if (!patientList?.length) {
        const getPatientsPayload: GetPatientsPayload = {
          apolloClient,
        };
        const getPatientsResponse = await getCurrentPatientsApi(getPatientsPayload);

        const currentPatientsList = getPatientsResponse?.data?.getCurrentPatients?.patients;
        const userId = currentPatientsList?.[0]?.id;

        if (!userId) {
          console.error("User Id Not Found");

          return;
        }

        localStorage.setItem("currentUser", userId);
        batch(() => {
          store.dispatch(updateCurrentPatientId(userId));
          store.dispatch(updatePatientList(currentPatientsList as Patient[]));
          store.dispatch(updateSignedInState(SignedinState.SIGNEDIN));
          store.dispatch(updateSignInError(false));
        });
      } else {
        const userId = primaryProfileId(patientList) || patientList?.[0]?.id; // Should not pick me by default
        const currentUserId = localStorage.getItem("currentUser"); // pick 0th always...

        batch(() => {
          if (currentUserId?.length || userId) {
            const patientIds = patientList.map((patient) => patient.id) || [];

            if (userId && !patientIds?.includes(currentUserId)) {
              localStorage.setItem("currentUser", userId);
              store.dispatch(updateCurrentPatientId(userId));
            } else {
              store.dispatch(updateCurrentPatientId(currentUserId));
            }
          }

          store.dispatch(updatePatientList(patientList));
          store.dispatch(updateSignedInState(SignedinState.SIGNEDIN));
          store.dispatch(updateSignInError(false));
        });

        if (userId) {
          const patient = patientList ? patientList.find((patient) => patient.id === currentUserId) : null;
          clevertapUserLoginTracking(patient);
        }
      }

      setCookie(LOGIN_COOKIE_NAME, "true", {
        sameSite: "Lax",
        expires: 1000,
        secure: true,
      });
    }
  } catch (err) {
    console.error("fire base calls error", err);

    store.dispatch(updateSignInError(true));
    performSignOutUpdates({ dispatch });
  }
}
